module.exports = __webpack_public_path__ + "static/media/drum.33ff57d3.svg";